import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("defs", null, [
    /*#__PURE__*/ _createElementVNode("filter", {
        id: "a",
        x: "-18.2%",
        y: "-28.1%",
        width: "136.4%",
        height: "164.2%",
        filterUnits: "objectBoundingBox"
    }, [
        /*#__PURE__*/ _createElementVNode("feOffset", {
            dy: "2",
            in: "SourceAlpha",
            result: "shadowOffsetOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feGaussianBlur", {
            stdDeviation: "5",
            in: "shadowOffsetOuter1",
            result: "shadowBlurOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feColorMatrix", {
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
            in: "shadowBlurOuter1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("filter", {
        id: "c",
        x: "-145.5%",
        y: "-127.3%",
        width: "390.9%",
        height: "390.9%",
        filterUnits: "objectBoundingBox"
    }, [
        /*#__PURE__*/ _createElementVNode("feOffset", {
            dy: "2",
            in: "SourceAlpha",
            result: "shadowOffsetOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feGaussianBlur", {
            stdDeviation: "5",
            in: "shadowOffsetOuter1",
            result: "shadowBlurOuter1"
        }),
        /*#__PURE__*/ _createElementVNode("feColorMatrix", {
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
            in: "shadowBlurOuter1"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        id: "b",
        d: "M4 0h80a4 4 0 014 4v33.867c0 6.627-5.373 12-12 12H4a4 4 0 01-4-4V4a4 4 0 014-4z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        id: "d",
        d: "M77 38.867h11c0 6.075-4.925 11-11 11v-11z"
    })
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M149.52 34h18.105c8.768 0 15.875 7.107 15.875 15.875v11.938a3.938 3.938 0 003.938 3.937 5.033 5.033 0 004.885-3.822l.364-1.47a6.97 6.97 0 016.765-5.291h2.423a8.275 8.275 0 018.265 7.865l4.31 86.872c.289 5.832-4.204 10.794-10.036 11.083a10.572 10.572 0 01-.524.013h-60.663c-5.84 0-10.573-4.733-10.573-10.572 0-.511.037-1.021.111-1.527l11.36-77.86h0c-7.249 0-13.125-5.876-13.125-13.124V52.52C131 42.292 139.292 34 149.52 34z",
        stroke: "#67D1E1",
        "stroke-width": ".5",
        fill: "#67D1E1"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "translate(174.313 78.98)" }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M7.854 13.064a7.793 7.793 0 008.387-2.268",
            stroke: "#00292B",
            "stroke-width": "1.982",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        }),
        /*#__PURE__*/ _createElementVNode("ellipse", {
            fill: "#00292B",
            cx: "1.313",
            cy: "1.323",
            rx: "1.313",
            ry: "1.323"
        }),
        /*#__PURE__*/ _createElementVNode("ellipse", {
            fill: "#00292B",
            cx: "17.063",
            cy: "1.323",
            rx: "1.313",
            ry: "1.323"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M170 68c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm26 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-14.5 11.5h3",
        stroke: "#FFF",
        "stroke-width": "2"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "rotate(1 -5134.284 4138.397)" }, [
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#000",
            filter: "url(#a)",
            "xlink:href": "#b"
        }),
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#F7F7FF",
            "xlink:href": "#b"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M82.924 104.787c1.933-.215 3.905-1.089 5.799-.643 3.981.937 6.415 6.596 8.899.79.575-1.344-1.487-3.263-2.502-2.257-2.94 2.913 5.608 3.398 6.119 3.335",
        stroke: "#6284D6",
        "stroke-width": "2",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#DDDBEA",
        "stroke-width": "2",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M82.183 126.262l48.392.845m-48.247-6.843l65.175 1.137m-65.07-7.136l65.175 1.137"
    }),
    /*#__PURE__*/ _createElementVNode("g", { transform: "rotate(1 -5134.284 4138.397)" }, [
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#000",
            filter: "url(#c)",
            "xlink:href": "#d"
        }),
        /*#__PURE__*/ _createElementVNode("use", {
            fill: "#FFF",
            "xlink:href": "#d"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M74.376 90.287l-.87 49.86a2.933 2.933 0 01-2.882-2.985l.768-43.993a2.933 2.933 0 012.984-2.882z",
        fill: "#6284D6"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M119.105 88.347l12.982-.68a1.336 1.336 0 011.404 1.263 7.836 7.836 0 11-15.65.82 1.336 1.336 0 011.264-1.403z",
        fill: "#67D1E1",
        "fill-rule": "nonzero"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        stroke: "#DDDBEA",
        "stroke-width": "2",
        style: { "mix-blend-mode": "multiply" },
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M134 162h78"
    })
], -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.progress.dialogs.your_turn')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ModalDialog from '@/components/ModalDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'YourTurnDialog',
    setup(__props) {
        const retroStore = useRetroStore();
        const { phase, isCurrentUserPosting, isReadyToShare } = storeToRefs(retroStore);
        function hideModal() {
            isReadyToShare.value = true;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                centered: "",
                "primary-actions": {
                    [_ctx.$t('confirm')]: hideModal
                },
                "dismiss-action": hideModal,
                show: _unref(phase) === 'posting' && _unref(isCurrentUserPosting) && !_unref(isReadyToShare)
            }, {
                before: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", {
                        width: "285",
                        height: "150",
                        viewBox: "0 30 285 150",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "svg-inline": '',
                        src: '@/assets/images/your-turn-image.svg',
                        alt: 'Your turn'
                    }, _hoisted_4, 8, _hoisted_1))
                ]),
                heading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('heading')), 1)
                ]),
                after: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('after')), 1)
                ]),
                _: 1
            }, 8, ["primary-actions", "show"]));
        };
    }
});
